import React from 'react'
import { groupBy } from 'lodash-es'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { NegotiationStatus, NegotiationDetail, UserPreference } from 'api'
import {
  HeroPanel,
  BannerStatusTile,
  BannerCurrencyTile,
  BannerTilesGroup,
  DetailTilesContainer,
  EnvironmentTitle,
  getNegotiationCashAmounts
} from 'view/shared/heroPanel'
import { createInitiatedTopLevelNegotiationsSelector } from 'selectors/negotiations'
import { initiatedNegotiationsCollectionNameSelector } from 'selectors/collectionSelectors'
import { createUserPreferenceSelector } from 'selectors/userPreferenceSelectors'
import { WindowActions } from 'epics/windowEpic'
import { Translation, Locale } from 'locale'
import * as constants from 'view/styles/constants'

interface InitiatedNegotiationsHeroPanelProps {
  currentNegotiations: NegotiationDetail[]
  collectionName: string | null
  userPreference: UserPreference
  onTearout: () => void
}

const mapStateToProps = createStructuredSelector({
  currentNegotiations: createInitiatedTopLevelNegotiationsSelector(true),
  collectionName: initiatedNegotiationsCollectionNameSelector,
  userPreference: createUserPreferenceSelector()
})

const mapDispatchToProps = {
  onTearout: () => WindowActions.tearoutGrid('/quote/tearout/rfqs/initiated')
}

class InitiatedNegotiationsHeroPanelComponent extends React.Component<InitiatedNegotiationsHeroPanelProps> {
  render() {
    const { currentNegotiations, collectionName, userPreference } = this.props
    const negotiationsByStatus = groupBy(currentNegotiations, negotiationDetail => negotiationDetail.negotiation.status)
    const unpricedNegotiations = negotiationsByStatus[NegotiationStatus.REQUESTED_WITHOUT_PRICE] || []
    const counteredNegotiations = negotiationsByStatus[NegotiationStatus.REQUESTED_WITH_PRICE] || []
    const pricedNegotiations = negotiationsByStatus[NegotiationStatus.QUOTED] || []
    const cashAmounts = getNegotiationCashAmounts(currentNegotiations)
    const title = `${Locale.translate(Translation.TC_HERO_INITIATED)} - ${collectionName || Locale.translate(Translation.TC_HERO_ALL)}`

    return (
      <HeroPanel onTearout={this.props.onTearout}>
        <DetailTilesContainer>
          <EnvironmentTitle
            data-test-id={'InitiatedNegotiationsHeroPanel-EnvironmentTitle'}
            maxWidth={cashAmounts.length > 0 ? 370 : undefined}>
            {title}
          </EnvironmentTitle>
          <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_STATUS)}>
            <BannerStatusTile
              title={Locale.translate(Translation.TC_UNPRICED)}
              label={unpricedNegotiations.length}
              statusColor={constants.STATUS_COLOR_DEFAULT}
            />
            <BannerStatusTile
              title={Locale.translate(Translation.TC_PRICED)}
              label={pricedNegotiations.length}
              statusColor={constants.STATUS_COLOR_RESPOND}
            />
            <BannerStatusTile
              title={Locale.translate(Translation.TC_COUNTERED)}
              label={counteredNegotiations.length}
              statusColor={constants.STATUS_COLOR_ACTIVE}
            />
          </BannerTilesGroup>
        </DetailTilesContainer>
        {cashAmounts.length > 0 && (
          <DetailTilesContainer large={true}>
            <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_CASH_AMOUNTS)}>
              {cashAmounts.map(cashAmount => (
                <BannerCurrencyTile key={cashAmount.currency} cashAmount={cashAmount} userPreference={userPreference} />
              ))}
            </BannerTilesGroup>
          </DetailTilesContainer>
        )}
      </HeroPanel>
    )
  }
}

export const InitiatedNegotiationsHeroPanel = connect(mapStateToProps, mapDispatchToProps)(InitiatedNegotiationsHeroPanelComponent)
